import _toConsumableArray from "/home/runner/work/options_website/options_website/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-toc').Options} Options
 */
import { toc } from 'mdast-util-toc';
/**
 * Plugin to generate a Table of Contents (TOC).
 *
 * @type {import('unified').Plugin<[Options?]|void[], Root>}
 */

export default function remarkToc() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (node) {
    var result = toc(node, Object.assign({}, options, {
      heading: options.heading || 'toc|table[ -]of[ -]contents?'
    }));

    if (result.endIndex === null || result.index === null || result.index === -1 || !result.map) {
      return;
    }

    node.children = [].concat(_toConsumableArray(node.children.slice(0, result.index)), [result.map], _toConsumableArray(node.children.slice(result.endIndex)));
  };
}